<!-- Skip Link -->
<a href="#main-content" class="skip-link">Skip to main content</a>

<app-header></app-header>

<main id="main-content">
  @if (contentVisible) {
    <router-outlet></router-outlet>
  }
</main>

<app-footer></app-footer>
